import React from 'react';
import { findIndex, union } from 'lodash';

import {
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';

import Tooltip from '../../../commonComponents/Tooltip';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
// import RequiredMark from '../../../commonComponents/RequiredMark';
import PartsSearchAreaCt from '../../../commonComponents/PartsSearchAreaCt';
import KeyPartStockModalCt from './KeyPartStockModalCt';

import custJqAjax from '../../../commonJS/custJqAjax';
// import autoFill from '../../../commonJS/autoFill';
import { textInputOnChange, dropDownOnChange } from '../../../commonJS/onFormChanges';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import inputValidation from '../../../commonJS/inputValidation';

const Hr = props => <hr style={{ borderTop: '1px solid #ddd', ...props.style }} />;

const BtnEditMode = props => {
  return (
    <Button
      onClick={props.onClick}
      disabled={props.disabled}
      style={
        {
          position: 'relative',
          padding: '0 6px',
          height: 28,
          float: 'right',
          marginLeft: 5,
          marginTop: props.inside ? 8 : -8
        }
      }>

      {props.title}

      {props.tipText ? <Tooltip tipText={props.tipText} placement="left" /> : ''}
    </Button>
  );
};

const ShippingListPs = props => (
  <div id='shipping-list-container'>
    {
      props.list.map((item, ind) => {
        return (
          <div key={ind} className='shipping-list-item' onClick={() => { props.onClick(item, 'selectedItemId'); }}>
            <Col sm={3} style={{ width: '20%' }}>
              {item.part_id}
            </Col>

            <Col sm={3} style={{ width: '20%' }}>
              {item.part_name}
            </Col>

            <Col sm={3} style={{ width: '20%' }}>
              {item.part_spec}
            </Col>

            <Col sm={3} style={{ width: '20%' }}>
              {item.unit}
            </Col>

            <Col sm={3} style={{ width: '20%' }}>
              {item.useage}
            </Col>
          </div>
        );
      })
    }
  </div>
);


export default class ShippingListCt extends React.PureComponent {
  constructor(props) {
    super(props);

    // 改數量以及按x時，更新label
    this.state = {
      appliance: '',
      currAccessoryId: '',
      currAccessoryVol: '',
      accessories: [], // 已選配件id清單
      accessorySpec: '', // 作用中配件規格
      optsAcces: [ // 配件選項
        { value: 1, label: '套筒夾頭 * 1', orinLabel: '套筒夾頭', vol: 1, spec: '套筒夾頭 規格' },
        { value: 2, label: '油霧回收機 * 1', orinLabel: '油霧回收機', vol: 1, spec: '油霧回收機 規格' },
        { value: 3, label: '刀具偵測臂 * 1', orinLabel: '刀具偵測臂', vol: 1, spec: '刀具偵測臂 規格' },
        { value: 4, label: '工件接收器 * 1', orinLabel: '工件接收器', vol: 1, spec: '工件接收器 規格' },
        { value: 5, label: '自動門 * 1', orinLabel: '自動門', vol: 1, spec: '自動門 規格' },
        { value: 6, label: '排屑機 * 1', orinLabel: '排屑機', vol: 1, spec: '排屑機 規格' },
        { value: 7, label: '自動送料裝置 * 1', orinLabel: '自動送料裝置', vol: 1, spec: '自動送料裝置 規格' }
      ],
      mainProduct: null,
      showPackageUI: false,
      selectedItemId: '',
      partId: '',
      partName: '',
      partSpec: '',
      usage: '',
      unit: '',
      process: '',
      supplierName: '',
      notes: '',
      optsShippingList: [],
      editMode: '',
      // parts search area
      showPartsSearchArea: false,
      // common
      btnSaveDisable: true
    };

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.handlers = {
      onShowPackageUI: (e) => {
        this.setState({ showPackageUI: true });
      },
      textInputOnChange: e => {
        const cb = e.currentTarget.id === 'currAccessoryVol' ? (id, value) => {
          // 更新目標選配選項之label與vol key值
          let cloneValue = value; // for pure function
          if (cloneValue === '') cloneValue = '1'; // 清空內容的情況, 設為預設值1，驗證套件只接受文字形態的數字

          cloneValue = inputValidation(cloneValue, { numberTest: true }).numberTest ? cloneValue : this.state.currAccessoryVol;

          // 轉數字形態
          cloneValue *= 1;

          const optsAcces = this.state.optsAcces.slice(),
            ind = findIndex(optsAcces, { value: this.state.currAccessoryId });

          optsAcces[ind].label = optsAcces[ind].orinLabel + ` * ${cloneValue}`;
          optsAcces[ind].vol = cloneValue;
          // 更新選項
          this.setState({ optsAcces });

          return cloneValue;
        } : undefined;

        textInputOnChange(e, this, cb);
      },
      dropDownOnChange: (selection, stateName) => {
        // test ==

        switch (stateName) {
          case 'accessories':
            const arr = [], len = selection.length, currAccessory = selection[len - 1] || { spec: "", vol: "" };

            for (let i = 0; i < len; i++) {
              arr.push(selection[i].value);
            }

            const optsAcces = this.state.optsAcces.slice(), optsLen = optsAcces.length;
            // 取消選擇時還原數量
            for (let i = 0; i < optsLen; i++) {
              if (arr.indexOf(optsAcces[i].value) === -1 && optsAcces[i].vol !== 1) {
                optsAcces[i].vol = 1;
                optsAcces[i].label = optsAcces[i].orinLabel + ` * 1`;
              }
            }

            this.setState({
              [stateName]: arr,
              accessorySpec: currAccessory.spec,
              currAccessoryVol: currAccessory.vol,
              currAccessoryId: currAccessory.value,
              optsAcces
            });
            return;
          case 'mainProduct':
            this.setState({
              mainProduct: selection
            });
            return;
          default:

        }

        // ===

        if (!selection.value) selection.value = selection.id;

        const obj = dropDownOnChange(selection, stateName);
        obj.partId = selection.part_id;
        obj.partName = selection.part_name;
        obj.partSpec = selection.part_spec;
        obj.usage = selection.useage;
        obj.unit = selection.unit;
        obj.process = selection.process;
        obj.supplierName = selection.supplier_name;
        obj.notes = selection.notes;
        if (this.state.editMode !== 'view') obj.editMode = 'view';

        this.setState(obj);
      },
      onAddItem: () => {
        this.setState(
          {
            selectedItemId: '',
            editMode: 'create',
            partId: '',
            partName: '',
            partSpec: '',
            usage: '',
            unit: '',
            process: '',
            supplierName: '',
            notes: ''
          },
          () => {
            document.getElementById('partId').focus();
          }
        );
      },
      onEditClick: () => {
        this.setState({ editMode: 'edit' });
      },
      onSaveItem: isUpdate => {
        const state = this.state,
          props = this.props;

        let formData = new FormData();


        formData.append('delivery_number', props.deliveryNumber);
        formData.append('process', state.process);
        formData.append('part_id', state.partId);
        formData.append('part_name', state.partName);
        formData.append('part_spec', state.partSpec);
        formData.append('useage', state.usage);
        formData.append('unit', state.unit);
        formData.append('supplier_name', state.supplierName);
        formData.append('notes', state.notes);

        if (isUpdate) {
          formData.append('id', state.selectedItemId);
        }

        custJqAjax({
          type: 'POST',
          url: `/api/W_ServiceSky_Delivery_Order_Detail_${isUpdate ? 'Update' : 'Post'}.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            this.setState({
              editMode: 'view',
              selectedItemId: res.result.id
            });

            this.handlers.onItemModified(res.result, isUpdate ? 'update' : 'create');
          }
        });
      },
      onDeleteItem: () => {
        let formData = new FormData(),
          id = this.state.selectedItemId;


        formData.append('id', id);

        custJqAjax({
          type: 'POST',
          url: '/api/W_ServiceSky_Delivery_Order_Detail_Delete.php',
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            this.handlers.onItemModified({ id }, 'delete');
          }
        });
      },
      onItemModified: (data, mode) => {
        // new obj for PureComponent
        const newShippingList = {
          loaded: true,
          data: this.props.shippingList.data
        };

        if (mode === "create") {
          newShippingList.data.unshift(data);
        } else if (mode === "update") {
          const updateInd = findIndex(newShippingList.data, { id: data.id });
          newShippingList.data[updateInd] = data;
        } else if (mode === "delete") {
          const updateInd = findIndex(newShippingList.data, { id: data.id });
          newShippingList.data.splice(updateInd, 1);
          this.setState({ editMode: '' });
        }

        this.props.parentStateHandler({ states: 'shippingList', newValues: newShippingList });

      },
      onTogglePartsSearchArea: () => {
        this.setState({ showPartsSearchArea: !this.state.showPartsSearchArea });
      },
      onAddToParts: (selectedPart) => {

        this.setState({
          partId: selectedPart.part_id,
          partName: selectedPart.part_name,
          partSpec: selectedPart.part_spec,
          unit: selectedPart.units,
          supplierName: selectedPart.supplier_name
        });

        this.handlers.onTogglePartsSearchArea();
      }
    };


    this.funcs = {
      optsShippingListGenerator: (data) => {
        return data.map((item, ind) => {
          return {
            value: item.id,
            label: `${item.part_id} / ${item.part_name} / ${item.part_spec}`,
            ...item
          };
        });
      },
      resetState: cb => {

        this.setState({
          mainProduct: null,
          accessorySpec: '',
          showPackageUI: false,
          selectedItemId: '',
          partId: '',
          partName: '',
          partSpec: '',
          usage: '',
          unit: '',
          process: '',
          supplierName: '',
          notes: '',
          optsShippingList: [],
          editMode: ''
        }, cb ? cb : "");
      }
    };


  }

  componentWillReceiveProps(nextProps) {
    if (this.props.shippingList !== nextProps.shippingList) {

      if (this.props.deliveryNumber !== nextProps.deliveryNumber) {
        this.funcs.resetState();
      }


      if (nextProps.shippingList.data.length !== 0) {
        // 清單有更新時才重新產生選項
        this.setState({
          optsShippingList: this.funcs.optsShippingListGenerator(nextProps.shippingList.data)
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // 資料驗證ok才可送出
    if (this.state.partId === '') {
      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) {
      this.setState({ btnSaveDisable: false });
    }
  }

  render() {
    const { languageData, languageCode } = window.myConsts;

    const state = this.state, props = this.props, handlers = this.handlers,
      { optsAcces } = state;

    let editable, placeholder, showDetailArea, modeText, modeBtns;

    if (state.editMode !== 'create') {
      if (props.shippingList.loaded) {
        if (props.shippingList.data.length === 0) {
          placeholder = '無明細資料。';
        }
      } else {
        placeholder = '讀取中…';
      }
    }

    if (state.editMode) {
      showDetailArea = true;

      const saveBtn = <BtnEditMode
        title='儲存'
        inside={true}
        disabled={state.btnSaveDisable}
        onClick={() => { handlers.onSaveItem(state.editMode === 'edit'); }} />;

      switch (state.editMode) {
        case 'create':
          modeText = '新增';
          editable = true;

          modeBtns = (
            <div style={{ float: 'right' }}>

              {saveBtn}

              {/* <BtnEditMode 
                title={(state.showPartsSearchArea ? '關閉' : '零件') + '查詢'}
                inside={true}
                onClick={handlers.onTogglePartsSearchArea} /> */}

              <BtnEditMode
                title="加入選配組合"
                inside={true}
                // 加入判斷若package無項目則disable並tooltip提示package無項目
                onClick={handlers.onShowPackageUI} />

            </div>
          );

          break;
        case 'edit':
          modeText = '編輯';
          editable = true;

          modeBtns = (
            <div style={{ float: 'right' }}>
              {saveBtn}

              <DeleteBtnWithConfirm
                onClick={handlers.onDeleteItem}
                style={{
                  position: 'relative',
                  padding: '0 6px',
                  height: 28,
                  float: 'right',
                  marginLeft: 5,
                  marginTop: 8
                }} />

            </div>
          );

          break;
        case 'view':
          modeText = '檢視';
          editable = false;

          modeBtns = (
            <BtnEditMode
              title='編輯'
              inside={true}
              onClick={handlers.onEditClick} />
          );

          break;
        default:

      }
    }

    return (
      <Row>

        <Col sm={12}>
          <div style={{ fontWeight: "bold", marginBottom: 5 }}>
            產品明細

            <BtnEditMode
              title="新增明細"
              // 暫時開放
              // tipText={props.deliveryNumber ? '' : '請先儲存出貨單'}
              // disabled={!props.deliveryNumber}
              disabled={props.viewOnly || false}
              onClick={handlers.onAddItem} />

          </div>
        </Col>

        <Col sm={12}>
          <Well style={{ marginBottom: 15 }}>
            {
              placeholder ||

              <Row>
                {
                  showDetailArea ?
                    <div>
                      {
                        state.showPackageUI ?
                          <KeyPartStockModalCt
                            filteredKeyPartsList={[] || state.filteredKeyPartsList}
                            parentStateHandler={this.parentStateHandler}
                            filteredKeyParts={[] || state.filteredKeyParts}
                            keyPartsListUpdater={this.funcs.keyPartsListUpdater}
                            productId={123 || props.params.productId}
                            accessories={state.accessories}
                            optsAcces={optsAcces}
                            union={union}
                            currAccessoryId={state.currAccessoryId}
                            findIndex={findIndex} />
                          : ""
                      }

                      <Col sm={12} style={{ fontWeight: 'bold' }}>
                        <span style={{ color: 'blue' }}>{modeText}</span>資料

                        {modeBtns}

                        <Hr />
                      </Col>

                      {
                        state.showPartsSearchArea ?
                          <Col sm={12}>
                            <PartsSearchAreaCt
                              languageCode={languageCode}
                              languageData={languageData}
                              onAddToParts={handlers.onAddToParts}
                              addBtnTitle='帶入資料' />

                            <hr style={{ margin: 20, borderTop: '1px dashed #ddd' }} />
                          </Col>
                          :
                          ""
                      }

                      <DropDownMenu
                        // labelStyle={{fontWeight: 'bold'}}
                        sm={6}
                        id="partId"
                        validationState={state.mainProduct ? null : 'error'}
                        required={true}
                        label='主產品'
                        options={[{ value: 1, label: 'OBK-305L', spec: 'OBK-305L spec' }, { value: 2, label: 'LOC-256T', spec: 'LOC-256T spec' }] || props.optsCompany}
                        disabled={!editable}
                        onChange={handlers.dropDownOnChange}
                        value={state.mainProduct}
                        stateName='mainProduct' />

                      {/* <Col sm={6}>
                        <FormGroup controlId="partId"
                          validationState={state.partId ? null : 'error'}>
                          <ControlLabel><RequiredMark />零件編號</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.partId}
                            style={{height: 36}} />
                        </FormGroup>
                      </Col> */}

                      <Col sm={6}>
                        <FormGroup controlId="partName">
                          <ControlLabel>數量</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.partName}
                            style={{ height: 36 }} />
                        </FormGroup>
                      </Col>

                      <Col sm={12}>
                        <FormGroup controlId="partName">
                          <ControlLabel>主產品規格</ControlLabel>
                          <FormControl
                            disabled={true}
                            type='text'
                            // onChange={handlers.textInputOnChange}
                            value={state.mainProduct ? state.mainProduct.spec : ''}
                            style={{ height: 36 }} />
                        </FormGroup>
                      </Col>

                      <Col sm={12}>
                        <FormGroup controlId="appliance">
                          <ControlLabel>產品應用</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.appliance}
                            style={{ height: 36 }} />
                        </FormGroup>
                      </Col>

                      <DropDownMenu
                        // labelStyle={{fontWeight: 'bold'}}
                        sm={12}
                        multi={true}
                        onValueClick={(opt, e) => {
                          this.setState({
                            accessorySpec: opt.spec,
                            currAccessoryVol: opt.vol,
                            currAccessoryId: opt.value
                          });
                        }}
                        label='選配清單'
                        options={optsAcces || props.optsCompany}
                        disabled={!editable}
                        onChange={handlers.dropDownOnChange}
                        value={state.accessories}
                        stateName='accessories' />

                      <Col sm={12}>
                        <div style={{ marginBottom: 5 }}>配件資訊 ( 點擊配件名稱切換顯示內容。 )</div>
                      </Col>

                      <Col sm={12}>
                        <Well style={{ marginBottom: 15, paddingBottom: 24 }}>
                          <Row>
                            <Col sm={10}>
                              <FormGroup controlId="partName">
                                <ControlLabel>規格</ControlLabel>
                                <FormControl
                                  disabled={true}
                                  type='text'
                                  // onChange={handlers.textInputOnChange}
                                  value={state.accessorySpec}
                                  style={{ height: 36 }} />
                              </FormGroup>
                            </Col>

                            <Col sm={2}>
                              <FormGroup controlId="currAccessoryVol">
                                <ControlLabel>數量</ControlLabel>
                                <FormControl
                                  disabled={!editable}
                                  type='text'
                                  onChange={handlers.textInputOnChange}
                                  value={state.currAccessoryVol}
                                  style={{ height: 36 }} />
                              </FormGroup>
                            </Col>

                          </Row>
                        </Well>
                      </Col>

                      <Col sm={6}>
                        <FormGroup controlId="partSpec">
                          <ControlLabel>單價</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.partSpec}
                            style={{ height: 36 }} />
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup controlId="usage">
                          <ControlLabel>小計</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.usage}
                            style={{ height: 36 }} />
                        </FormGroup>
                      </Col>

                      {/* <Col sm={6}>
                        <FormGroup controlId="unit">
                          <ControlLabel>單位</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.unit}
                            style={{height: 36}} />
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup controlId="process">
                          <ControlLabel>站別</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.process}
                            style={{height: 36}} />
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup controlId="supplierName">
                          <ControlLabel>供應商</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.supplierName}
                            style={{height: 36}} />
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup controlId="notes">
                          <ControlLabel>備註</ControlLabel>
                          <FormControl
                            disabled={!editable}
                            type='text'
                            onChange={handlers.textInputOnChange}
                            value={state.notes}
                            style={{height: 36}} />
                        </FormGroup>
                      </Col> */}

                      <Col sm={12}>
                        <Hr />
                      </Col>
                    </div>
                    :
                    ""
                }

                {
                  props.shippingList.data.length !== 0 ?
                    <div>
                      <Col sm={12} style={{ fontWeight: 'bold', marginBottom: -5 }}>
                        搜尋明細
                        <Hr />
                      </Col>

                      <DropDownMenu
                        labelStyle={{ fontWeight: 'bold' }}
                        sm={12}
                        // label='搜尋明細'
                        options={state.optsShippingList}
                        // disabled={!editable}
                        onChange={handlers.dropDownOnChange}
                        value={state.selectedItemId}
                        stateName='selectedItemId' />

                      <Col sm={12}>
                        <Hr />
                      </Col>

                      <Col sm={12} style={{ fontWeight: 'bold' }}>
                        明細清單
                        <Hr />
                      </Col>

                      <div style={{ fontWeight: 'bold', height: 36, lineHeight: '36px' }}>
                        <Col sm={3} style={{ width: '20%' }}>
                          產品名稱
                        </Col>

                        <Col sm={3} style={{ width: '20%' }}>
                          選配
                        </Col>

                        <Col sm={3} style={{ width: '20%' }}>
                          數量
                        </Col>

                        <Col sm={3} style={{ width: '20%' }}>
                          單價
                        </Col>

                        <Col sm={3} style={{ width: '20%' }}>
                          小計
                        </Col>
                      </div>

                      <ShippingListPs list={props.shippingList.data} onClick={handlers.dropDownOnChange} />

                    </div>
                    :
                    ""
                }
              </Row>
            }
          </Well>
        </Col>

      </Row>

    );
  }

}



// WEBPACK FOOTER //
// ./src/salesky/routes/salesCases/ShippingListCt.jsx